import { createStyles } from "@mantine/core";

const useStyles = createStyles(() => ({
  card: {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%",
    padding: "1rem",
    backgroundColor: "#fff",
    borderRadius: "10px",
    border: "1px solid #E5E5E5",
    cursor: "pointer",
  },
  titleIndicator: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  loaderStyling: {
    display: "block",
    margin: "0 auto",
  },
  setupBtn: {
    padding: "12px 20px !important",
    borderRadius: "8px !important",
    border: "1px solid #FFAF4A !important",
    backgroundColor: "#FFAF4A !important",
    height: "44px !important",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05) !important",
    fontSize: "16px !important",
    fontWeight: "600 !important",
    fontFamily: "Inter !important",
    color: "#262626 !important",
    "&:hover": {
      backgroundColor: "#FFAF4A !important",
      opacity: "0.8 !important",
    },
  },
  cancelBtn: {
    padding: "12px 20px !important",
    borderRadius: "8px !important",
    border: "1px solid #D0D5DD !important",
    backgroundColor: "#F9FAFB !important",
    height: "44px !important",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05) !important",
    fontSize: "16px !important",
    fontWeight: "600 !important",
    fontFamily: "Inter !important",
    color: "#262626 !important",
    "&:hover": {
      backgroundColor: "#F9FAFB !important",
      opacity: "0.8 !important",
    },
  },
}));

export default useStyles;
